// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"454":"Citas","669":"Envios","959":"Avisos","968":"Inicio"}[chunkId] + "." + {"454":"d46022fc","669":"46572e2d","959":"3a8b18a5","968":"cc98c06f"}[chunkId] + ".css";
};